<template>
    <div class="d-flex flex-column justify-content-center align-items-center">
        <a
            @click="modal=true"
            href="#"
            class="avatar avatar-xl rounded-circle"
            style="width: 220px; height: 220px"
        >
            <img alt="Image placeholder" :src="src" />
        </a>
        <UploadDropzoneModal
            :modal="modal"
            @close="modal=false"
            @success="fileChange"
            v-model="file"
        ></UploadDropzoneModal>
    </div>
</template>

<script>
import UploadDropzoneModal from '../Common/Upload/UploadDropzoneModal';
import imageMixin from '../../mixins/image';

export default {
    name: 'PhotoSelector',
    mixins: [imageMixin],

    components: {
        UploadDropzoneModal,
    },

    props: {
        photo: {
            type: Object | null,
            required: true,
        },
    },

    data() {
        return {
            modal: false,
            file: [],
            src: '',
        };
    },

    methods: {
        openPhotoSelector() {
            this.$refs.fileInput.click();
        },
        fileChange(evt) {
            this.file = evt;
            this.src = this.image(evt);
            this.$emit('changePhoto', evt);
            this.modal = false;
        },
    },
    mounted() {
        this.src = this.image(this.photo);
    },
};
</script>

<style>
</style>
